export default __webpack_public_path__ + "static/subset-UniNeueBook-f990bb524b65074869dd72905aba718a.woff";